/* followfood: Meilensteine-Timeline — Scroll-Logik ohne sichtbare Scrollbar.
   Pfeil-Buttons (eine "Seite" pro Klick), Drag-to-scroll (Pointer), Disabled-States
   an den Enden. Buttons + Drag nur, wenn tatsächlich Overflow vorhanden ist. */
(function () {
  function init(root) {
    if (!root || root.dataset.ffTlReady === '1') return;
    var scroller = root.querySelector('[data-ff-tl-scroller]');
    if (!scroller) return;
    root.dataset.ffTlReady = '1';

    var prev = root.querySelector('[data-ff-tl-prev]');
    var next = root.querySelector('[data-ff-tl-next]');

    function step() {
      var card = scroller.querySelector('.ff-about-timeline__card');
      if (!card) return Math.round(scroller.clientWidth * 0.8);
      var styles = getComputedStyle(scroller.querySelector('.ff-about-timeline__track') || scroller);
      var gap = parseFloat(styles.columnGap || styles.gap || '20') || 20;
      var cardW = card.getBoundingClientRect().width + gap;
      // ganze sichtbare Seite (auf Kartenraster gerundet, min. 1 Karte)
      var perPage = Math.max(1, Math.floor(scroller.clientWidth / cardW));
      return Math.round(cardW * perPage);
    }

    function update() {
      var overflow = scroller.scrollWidth - scroller.clientWidth;
      var scrollable = overflow > 2;
      root.classList.toggle('is-scrollable', scrollable);
      if (prev) prev.disabled = !scrollable || scroller.scrollLeft <= 1;
      if (next) next.disabled = !scrollable || scroller.scrollLeft >= overflow - 1;
    }

    if (prev) prev.addEventListener('click', function () { scroller.scrollBy({ left: -step(), behavior: 'smooth' }); });
    if (next) next.addEventListener('click', function () { scroller.scrollBy({ left: step(), behavior: 'smooth' }); });
    scroller.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);

    /* Drag-to-scroll (Maus/Pen; Touch nutzt natives Scrollen) */
    var down = false, startX = 0, startLeft = 0, moved = false;
    scroller.addEventListener('pointerdown', function (e) {
      if (e.pointerType === 'touch') return;          // Touch: nativ
      if (e.pointerType === 'mouse' && e.button !== 0) return;
      down = true; moved = false; startX = e.clientX; startLeft = scroller.scrollLeft;
      scroller.classList.add('is-dragging');
    });
    scroller.addEventListener('pointermove', function (e) {
      if (!down) return;
      var dx = e.clientX - startX;
      if (Math.abs(dx) > 3) moved = true;
      scroller.scrollLeft = startLeft - dx;
    });
    function endDrag() {
      if (!down) return;
      down = false;
      scroller.classList.remove('is-dragging');
    }
    scroller.addEventListener('pointerup', endDrag);
    scroller.addEventListener('pointercancel', endDrag);
    scroller.addEventListener('pointerleave', endDrag);
    /* Klick nach echtem Drag unterdrücken (sonst löst ein Link/Karte versehentlich aus) */
    scroller.addEventListener('click', function (e) {
      if (moved) { e.preventDefault(); e.stopPropagation(); moved = false; }
    }, true);

    /* Bilder können nach Lazy-Load die Breite ändern → nach load erneut messen */
    scroller.querySelectorAll('img').forEach(function (img) {
      if (!img.complete) img.addEventListener('load', update, { once: true });
    });

    update();
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-ff-tl]').forEach(init);
  }

  if (document.readyState !== 'loading') initAll();
  else document.addEventListener('DOMContentLoaded', function () { initAll(); });

  /* Shopify Theme Editor: Section neu geladen → erneut initialisieren */
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
